import React, {Component} from 'react'
import {authenticationService} from '../../../services/AuthenticationService';
import SvGraphics from "../../../assets/SvGraphics";
import * as Yup from "yup";
import validationHelper from "../../../utils/validationHelper";
import utils from "../../../utils/utils";
import Error from "../../../components/single_components/Error";
import Config from "../../../config/Config";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {history} from "../../../utils/history";
import ReCaptcha from "../ReCaptcha";
import LeumitLogo from "../../../assets/LeumitLogo.png"
import {appendIchilovQuery, hasIchilovQuery} from "../../../utils/routeUtils";
import ichilovImg from "../../../assets/Soraski.svg";

class LeumitLogin2FAComposed extends Component {
    constructor(props) {
        super(props);

        if (!authenticationService.currentMfaUserValue) {
            this.props.history.push('/');

        }
        this.recaptchaRef = React.createRef()

        this.state = {
            twoFA: '',
            auth: {},
            isErr: false,
            errMessage: '',
            errors: {},
            errorsOnSave: {},
        }
    }

    initValidation = async () => {
        let {t} = this.props
        let validationSchema = Yup.object().shape({twoFA: Yup.string().required(t('defaults.TwoFA.auth_cd_req'))})
        let errors = await validationHelper.validate(this.state.auth, validationSchema)
        await this.setState({
            validationSchema,
            errors
        })
    }

    async componentWillMount() {
        await this.initValidation()
    }

    onSubmit = async () => {
        let isLocal = process.env.REACT_APP_ENV === 'localhost'

        if (!isLocal) {
            await this.recaptchaRef.reset()
            await this.recaptchaRef.execute()
        } else {
            await this.submitData("NOTOKENINLOCAL");
        }

    }
    submitData = async (reCaptchaToken) => {
        let {t} = this.props
        if (!utils.isEmpty(this.state.errors)) {
            this.setState({errorsOnSave: this.state.errors});
            return;
        }
        let {twoFA} = this.state
        let response = await authenticationService.submit2fa(twoFA, reCaptchaToken);
        if (response.status < 400) {
            let data = response.data
            if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === 'pass') {
                if (data.hasOwnProperty('updatePassword') && data['updatePassword'] === true) {
                    let patientInfo = data
                    history.push({
                        pathname: appendIchilovQuery(`/pain_create_password`),
                        state: {
                            patientInfo,
                            from: {
                                fromPath: `/pain_2FA`,
                            }
                        },
                    })
                } else if (data.hasOwnProperty('updatePassword') && data['updatePassword'] === false) {

                    let patientInfo = data
                    history.push({
                        pathname: appendIchilovQuery(`/pain_patient_self_onboard`),
                        state: {
                            patientInfo,
                            from: {
                                fromPath: `/pain_patient_self_onboard`,
                            }
                        },
                    })
                }
            } else {
                await this.setUserName({target: {value: ''}})
                await this.setPassword({target: {value: ''}})
                this.setState({
                    twoFA: '',
                    isErr: true,
                    errMessage: response.data ? response.data.message : t('defaults.login.connectionError'),
                })
            }
        } else {
            this.setState({
                twoFA: '',
                isErr: true,
                errMessage: response.data ? response.data.message : t('defaults.login.connectionError'),
            })
        }
    }

    setMFA = async (e) => {
        let {auth, validationSchema} = this.state
        this.setState({twoFA: e.target.value.trim()})
        utils.set(auth, 'twoFA', e.target.value.trim())
        let errors = await validationHelper.validate(auth, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, 'twoFA')) {
            utils.set(errorsOnSave, 'twoFA', utils.get(errors, 'twoFA'))
        }
        this.setState({
            auth,
            errors,
            errorsOnSave,
            isErr: false, errMessage: ''
        })
    }

    render() {
        let {t} = this.props
        let isLocal = process.env.REACT_APP_ENV === 'localhost'

        return (
            <div className={"login-page-Leumit"}>
                <div className={'sade-Pain-login-logo-container'}>
                    <SvGraphics svgname={'painClinicLogo'} className={'sade-Pain-login-logo'}/>
                    {hasIchilovQuery() ? <img src={ichilovImg} className={'sade-Pain-login-logo'} alt={""}/> :
                        <img src={LeumitLogo} className={'sade-Pain-login-logo'} alt={""}/>
                    }
                </div>
                <div className={'sade-login-main-board'}>
                    <label className={'sade-login-label-reset-Leumit'}>{t('defaults.rst_pwd.rst_pwd')}</label>
                    <div className={'sade-login-form-container-reg'}>
                        <div className={'sade-Pain-login-form'}>
                            <div>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-field"}
                                           placeholder={t('defaults.TwoFA.valid_cd')}
                                           type={"text"}
                                           name={"twoFA"}
                                           value={this.state.twoFA}
                                           onChange={e => this.setMFA(e)}
                                           onKeyPress={event => {
                                               if (event.key === 'Enter') {
                                                   this.onSubmit()
                                               }
                                           }}/>
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'twoFA') ? "input-pic2" : "input-pic"}
                                        svgname={'lock'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'twoFA')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'twoFA')}/>
                            </div>


                            <div className="form-group leumit-login-form-group">
                                <button className="sade-login-form-button"
                                        onClick={() => this.props.history.goBack()}>>{t('defaults.TwoFA.back_to_login')}</button>
                            </div>
                        </div>
                    </div>
                    <div className={'leumit-login-form-group loginError red h-centered'}>
                        <Error isNonFloat={true}
                               errorMessage={t('defaults.rst_pwd.auth_err') + ': ' + this.state.errMessage}
                               isShown={this.state.isErr}/>
                    </div>
                    <div className={'leumit-login-footer-container2'}
                         onClick={() => this.goBack()}>
                        <a>{t('defaults.rst_pwd.back_to_login')}</a>
                    </div>
                </div>


                <div className={'sade-Pain-bottom-container2'}>
                    <div className="need-help-label">
                        {t('defaults.Registration.need_help')}
                    </div>

                    <div className="need-help-block">

                        <div className="need-help-block-content">
                            <SvGraphics svgname={'global'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} target={"_blank"}
                                   href={'https://www.sade.group/he/pain'}>www.sade.group</a>
                            </div>

                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'email-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="mailto: pain@sade.group">pain@sade.group</a>
                            </div>

                        </div>


                        <div className="need-help-block-content">
                            <SvGraphics svgname={'phone-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} href="tel:073-380-7972">073-380-7972</a>
                            </div>
                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'clock'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="">{t('patient_self_boarding.workingHours')}</a>
                            </div>

                        </div>
                    </div>
                </div>


                <div className={'login-version-element'}>
                        <div className={'login-version-element-label'}>Version:</div>
                        <div className={'login-version-element-value'}>{Config.version} {Config.build}</div>
                    </div>
                {!isLocal && <div className={'recaptcha-block'}>
                    <ReCaptcha setRef={ref => (this.recaptchaRef = ref)}
                               action={async (reCaptchaToken) => {
                                   await this.submitData(reCaptchaToken);
                               }}
                        /*setErr={ this.setRecapchaErrors()}*//>
                </div>}

            </div>

        )
    }
}

let PainLogin2FA = compose(
    withTranslation()
)(LeumitLogin2FAComposed)

export default PainLogin2FA;
